import React, { useState } from "react";
import { Box, Grid, Stack } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import AddIcon from "@mui/icons-material/Add";

import PrimaryButton from "../../../components/Button/Button";
import FormDialog from "../../../components/Dialog/FormDialog";
import CreateService from "./CreateService";

function Heading() {
  const isMobile = useMediaQuery({ maxWidth: "900px" });

  const [anchorEl, setAnchorEl] = useState(false);

  const handleClose = () => {
    setAnchorEl(false);
  };
  const handleClick = () => {
    setAnchorEl(true);
  };
  return (
    <>
      {anchorEl && (
        <FormDialog
          open={anchorEl}
          handleClose={handleClose}
          title={"Add Service"}
          btnTitle={"Confirm"}
        >
          <CreateService onClose={handleClose} />
        </FormDialog>
      )}
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={2}
          className="d-flex align-items-center justify-content-space-between"
        >
          <Grid item xs={6} md={6}>
            <p className="page-heading-name">Services</p>
          </Grid>
          <Grid className={`d-flex justify-content-end`} item xs={6} md={6}>
            <Stack direction="row">
              <PrimaryButton
                variant="contained"
                className="capitalize btn-bg-orange"
                onClick={handleClick}
                startIcon={<AddIcon />}
              >
                Add Service
              </PrimaryButton>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Heading;
